module.exports = __webpack_public_path__ + "img/category-favorite-hover.7d658ae5.png";